const selectors = {
  imageGridSelector: '.product-img-box-grid',
  imageGridArrow: '.product-media-arrow__indicator'
};

const classes = {
  hide: 'scroll',
};

function hideArrow () {
  var imageGrid = document.querySelector(selectors.imageGridSelector);
  var moreImageArrow = document.querySelector(selectors.imageGridArrow);

  moreImageArrow.classList.add(classes.hide)
  imageGrid.removeEventListener('scroll', hideArrow);
}


function hideMediaArrow() {
  var imageGrid = document.querySelector(selectors.imageGridSelector);
  var moreImageArrow = document.querySelector(selectors.imageGridArrow);

  if (imageGrid && moreImageArrow) {
    imageGrid.addEventListener('scroll', hideArrow);
  }
}

export default hideMediaArrow;
